import { ROLES } from '../Permission'

export const MY_COMMUNITY_TABS = [
  {
    key: 'my_organization',
    label: 'My organization'
  },
  {
    key: 'communities',
    label: 'Communities'
  },
  {
    key: 'vendors',
    label: 'Vendors'
  },
  {
    key: 'commons',
    label: 'OM Lifeline'
  }
]
export const MY_COMMUNITY_TABS_GPO = [
  {
    key: 'my_organization',
    label: 'My organization'
  }
]

export const MY_COMMUNITY_TABS_WITH_GPO = [
  {
    key: 'communities',
    label: 'Communities'
  },
  {
    key: 'gpo',
    label: 'GPO'
  },
  {
    key: 'vendors',
    label: 'Vendors'
  },
  {
    key: 'commons',
    label: 'OM Lifeline'
  }
]
export const MY_COMMUNITY_TABS_COMMONS = [
  {
    key: 'my_organization',
    label: 'My organization'
  },
  {
    key: 'communities',
    label: 'Communities'
  },
  {
    key: 'vendors',
    label: 'Vendors'
  },
  {
    key: 'gpo',
    label: 'GPO'
  }
]

export const MY_COMMUNITY_USER_STATUSES = [
  {
    label: 'Active',
    value: 'Active'
  },
  {
    label: 'Invited',
    value: 'Invited'
  },
  {
    label: 'Archived',
    value: 'Archived'
  },
  {
    label: 'Pending',
    value: 'Pending'
  }
]

export const MY_COMMUNITY_KEYS = {
  communities: 'communities',
  gpo: 'gpo',
  vendors: 'vendors',
  commons: 'commons',
  gpo_details: 'gpo_details',
  vendor_details: 'vendor_details',
  my_organization: 'my_organization'
}

export const excludeVendorAndMyOrganizationTab = [
  ROLES.COMMUNITY_RCA
] as string[]
